import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Calendar } from "lucide-react";
import { fetchBlogPosts } from "@/lib/api";

const fmt = (iso) => new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });

export default function BlogPage() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { fetchBlogPosts().then(setPosts).catch(() => setPosts([])); }, []);

  return (
    <div data-testid="blog-page" className="bg-white">
      <section className="border-b border-slate-200">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16 md:py-20">
          <div className="text-xs uppercase tracking-widerest text-slate-500 font-mono-plex">The Founder&apos;s Notebook</div>
          <h1 className="mt-3 font-display font-bold tracking-tighter text-4xl md:text-5xl lg:text-6xl text-slate-950 max-w-3xl leading-[0.95]">
            Straight-talk on IT careers, certifications, and the job market.
          </h1>
          <p className="mt-6 text-slate-600 text-base md:text-lg max-w-2xl">
            Written by Gurudeva K B — founder of HCS Computers AI — and drawn from 20+ years of training and consulting.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-6 lg:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map((p) => (
            <Link
              key={p.id}
              to={`/blog/${p.slug}`}
              data-testid={`blog-card-${p.slug}`}
              className="group border border-slate-200 bg-white flex flex-col hover:-translate-y-1 hover:shadow-lg transition-all"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <div className="flex items-center gap-3 text-xs text-slate-500 font-mono-plex uppercase tracking-widerest">
                  <Calendar className="w-3.5 h-3.5" />{fmt(p.published_at)}
                </div>
                <h3 className="mt-3 font-display text-xl font-semibold tracking-tight text-slate-950">{p.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{p.excerpt}</p>
                <div className="mt-6 pt-4 border-t border-slate-100 flex items-center justify-between">
                  <div className="flex flex-wrap gap-1">
                    {p.tags.map((t) => (
                      <span key={t} className="text-[11px] px-2 py-0.5 border border-slate-200 text-slate-700 bg-slate-50">{t}</span>
                    ))}
                  </div>
                  <ArrowUpRight className="w-5 h-5 text-slate-400 group-hover:text-[#0052FF] transition-colors" />
                </div>
              </div>
            </Link>
          ))}
          {posts.length === 0 && <div className="col-span-full text-slate-500 text-sm">Loading articles…</div>}
        </div>
      </section>
    </div>
  );
}
